module.exports = __webpack_public_path__ + "static/media/PrescriptionGreen.d5555d2c.png";